import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import { DashboardGuard } from "./DashboardGuard";

const DashboardLayout = () => {
  return (
    <DashboardGuard>
      <Flex>
        <Box display={{ base: 'none', md: 'block' }}>
          <Sidebar />
        </Box>
        <Flex direction="column" flex="1" minW={0}>
          <Topbar />
          <Box as="main" p="1rem" bg="dashboard.bg.canvas" h="100vh" overflowX="hidden">
            <Outlet />
          </Box>
        </Flex>
      </Flex>
    </DashboardGuard>
  );
};

export default DashboardLayout;
